import React, { useContext } from 'react';

export const OfflineQueueContext = React.createContext({
	isOnline: true,
	isReady: false,
	isFlushing: false,
	queue: [],
	enqueue: async () => {},
	remove: async () => {},
	flush: async () => {},
	waitUntilReady: async () => true,
});

export const useOfflineQueue = () => useContext(OfflineQueueContext);
